<input placeholder="Cerca per nome..." pInputText class="w-full" #query (input)="dt1.filterGlobal([query.value] , '')">

<p-table 
[value]="travelers" 
[paginator]="true"
[rows]="5"
[lazy]="true"
(onLazyLoad)="getTravelers($event)"
[totalRecords]="totalRecords"
[showCurrentPageReport]="true"
currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali"
#dt1
>
    <ng-template pTemplate="header">
        <tr>
            <th>Traveler</th>
            <th>Email</th>
            <th>Tipo di traveler</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-t>
        <tr>
            <td>
                <div class="flex align-items-center gap-2">
                    <p-avatar [image]="t.profile_picture | imagePipe:'user':'sm'"
                        shape="circle"></p-avatar>
                    <div>
                        @if(t.name){
                            <a class="link-o" [routerLink]="['/user/profile', t.username]"><strong>{{t.name}} {{t.last_name}}</strong></a>
                        }@else {
                            <a class="link-o" [routerLink]="['/user/profile', t.username]"><strong>{{t.username}}</strong></a>
                        }
                        <!-- <small class="grey-text">
                            <i class="pi pi-users"></i>
                            Followers: ...
                        </small> -->
                    </div>
                </div>
            </td>
            <td>{{t.email}}</td>
            <td class="badge_mod" [innerHTML]="t.role | showRole:true"></td>
        </tr>
    </ng-template>
</p-table>